import { CustomOrderImportSchemaSchema } from "@redotech/redo-model/outbound-labels/import-schema";
import * as z from "zod";

export const getCustomImportSchemas = {
  name: "getCustomImportSchemas" as const,
  input: z.object({}),
  output: z.object({ schemas: z.array(CustomOrderImportSchemaSchema) }),
};
